import React from 'react';
import PropTypes from 'prop-types';

import {
  Link,
} from 'react-router-dom';

import routes from 'app/routes';

export default function BackButton({
  title, source, sourceId, loading,
}) {
  let url = routes.members.schedule.index;
  if (source === 'program') {
    url = routes.members.programs.show(sourceId);
  }

  return (

    <Link
      to={url}
      className={`btn btn-outline-primary ${loading ? 'disabled' : ''}`}
    >
      {title}
    </Link>
  );
}

BackButton.propTypes = {
  title: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  sourceId: PropTypes.number,
  loading: PropTypes.bool.isRequired,
};

BackButton.defaultProps = {
  sourceId: null,
};
